import { clsx } from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';
import { NavLink } from 'react-router';

export const SidebarNavItem: FunctionComponent<
    PropsWithChildren<{
        to: string;
    }>
> = ({ to, children }) => {
    return (
        <li>
            <NavLink
                className={({ isActive }) => {
                    return clsx('group flex items-center gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-400 hover:bg-gray-800 hover:text-white', {
                        'bg-gray-800 text-white': isActive,
                    });
                }}
                to={to}
            >
                {children}
            </NavLink>
        </li>
    );
};
